import React from 'react';
import './Hero.css';
import FlowField from './FlowField';

const AUDIT_EMAIL_URL = 'mailto:salma@digitalshifts.studio?subject=Automation%20audit%20assessment%20survey';

const stats = [
  { value: '25+', label: 'Automations built' },
  { value: '3×', label: 'Avg. time saved' },
  { value: '100%', label: 'Custom-built' },
];

export default function Hero() {
  return (
    <section className="hero" id="top">
      {/* Background layers */}
      <div className="hero-bg">
        <div className="hero-cinematic" />
        <div className="hero-glow-top" />
        <div className="hero-glow-left" />
        <div className="hero-grid" />
        <FlowField />
        <div className="hero-vignette" />
      </div>

      <div className="hero-inner">
        {/* Badge */}
        <div className="hero-badge">
          <span className="badge-dot" />
          AI automation agency
        </div>

        {/* Heading */}
        <h1 className="hero-title">
          Transform Your Business<br />
          with <span className="hero-accent">AI-Driven Automation</span>
        </h1>

        {/* Subtext */}
        <p className="hero-sub">
          We digitalize fragmented operations, automate repetitive execution,
          then integrate AI where it drives measurable leverage.
        </p>

        {/* CTAs */}
        <div className="hero-ctas">
          <a href="#services" className="btn-primary hero-cta-primary">
            Discover Our Services
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
          <a href={AUDIT_EMAIL_URL} className="btn-outline">Request a Free Audit</a>
        </div>

        {/* Stats row */}
        <div className="hero-stats">
          {stats.map((s, i) => (
            <div className="hero-stat" key={i}>
              <span className="stat-value">{s.value}</span>
              <span className="stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="hero-scroll-hint">
        <div className="scroll-line" />
      </div>
    </section>
  );
}
